var emailValidator = /** @class */ (function () {
    function emailValidator() {
    }
    emailValidator.match = function (AC) {
        var mail = AC.get("email").value;
        var repeat = AC.get("repeatEmail").value;
        if (mail !== repeat) {
            AC.get("repeatEmail").setErrors({ match: true });
        }
        else {
            return null;
        }
    };
    return emailValidator;
}());
export { emailValidator };
var PasswordValidation = /** @class */ (function () {
    function PasswordValidation() {
    }
    PasswordValidation.MatchPassword = function (AC) {
        var password = AC.get("contrasena").value;
        var confirmPassword = AC.get("repContrasena").value;
        if (password !== confirmPassword) {
            AC.get("repContrasena").setErrors({ MatchPassword: true });
        }
        else {
            return null;
        }
    };
    return PasswordValidation;
}());
export { PasswordValidation };
